import {Alert, Snackbar} from "@mui/material";
import ErrorOutlineOutlinedIcon from "@mui/icons-material/ErrorOutlineOutlined";
import CheckCircleOutlineOutlinedIcon from "@mui/icons-material/CheckCircleOutlineOutlined";
import React, {useContext, useEffect, useState} from "react";
import {AppContext} from "../contexts/AppContextProvider";

const NotificationProvider: React.FC = ({children}) => {
    const [open, setOpen] = useState(false)
    const {notification} = useContext(AppContext)

    useEffect(() => {
        setOpen(!!notification)
    }, [notification]);

    return (
        <>
            {children}
            <Snackbar
                open={open}
                autoHideDuration={6000}
                onClose={() => setOpen(false)}
                anchorOrigin={{vertical: 'bottom', horizontal: 'center'}}
            >
                <div style={{marginTop: '1rem'}}>
                    {notification && (
                        <Alert
                            icon={
                                notification[0] === 'error' ? (
                                    <ErrorOutlineOutlinedIcon fontSize='large'/>
                                ) : (
                                    <CheckCircleOutlineOutlinedIcon fontSize='large'/>
                                )
                            }
                            style={{padding: 30, fontSize: '1.35em'}}
                            sx={{
                                '& .MuiAlert-action': {
                                    mt: '.5rem',
                                },
                            }}
                            onClose={() => setOpen(false)}
                            severity={notification[0]}
                        >
                            {notification[1]}
                        </Alert>
                    )}
                </div>
            </Snackbar>
        </>
    )
}

export default NotificationProvider
